import React from 'react'
import clsx from 'clsx'

import { Link } from '@/i18n/navigation'

import styles from './Logo.module.scss'

const Logo = ({ className }: { className?: string }) => (
  <Link
    href='/'
    className={clsx(styles.logo, className)}
  >
    <svg
      aria-label='NABA - Nuova Accademia Belle Arti'
      width='158'
      height='45'
      viewBox='0 0 158 45'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M49.6855 3.87402H51.0767L56.4428 11.0269V3.87402H57.9333V13.2125H56.4428L51.0767 5.96028V13.2125H49.6855V3.87402Z'
        fill='white'
      />
      <path
        d='M60.2189 9.13933V3.87402H61.6101V8.94064C61.6101 11.4243 63.2 11.921 64.1937 11.921C65.2868 11.921 66.8767 11.3249 66.8767 8.94064V3.87402H68.2679V9.13933C68.2679 12.219 66.7774 13.4112 64.1937 13.4112C61.8088 13.4112 60.2189 12.219 60.2189 9.13933Z'
        fill='white'
      />
      <path
        d='M77.9069 8.44436C77.9069 7.15287 77.4101 5.06662 74.9258 5.06662C72.4415 5.06662 71.9447 7.15287 71.9447 8.44436C71.9447 9.8352 72.5409 12.0208 74.9258 12.0208C77.2113 12.0208 77.9069 9.93454 77.9069 8.44436ZM70.4541 8.44436C70.4541 6.45745 71.3484 3.67578 74.9258 3.67578C78.5032 3.67578 79.3975 6.45745 79.3975 8.44436C79.3975 10.63 78.3044 13.4116 74.9258 13.4116C71.5472 13.4116 70.4541 10.63 70.4541 8.44436Z'
        fill='white'
      />
      <path
        d='M80.59 3.87402H82.1799L85.161 11.7223L88.1422 3.87402H89.6327L86.0554 13.2125H84.2667L80.59 3.87402Z'
        fill='white'
      />
      <path
        d='M96.2909 9.03999L94.6016 4.96682L93.0117 9.03999H96.2909ZM93.8066 3.87402H95.4959L99.3714 13.2125H97.8808L96.6884 10.4308H92.4154L91.223 13.2125H89.7324L93.8066 3.87402Z'
        fill='white'
      />
      <path
        d='M56.0453 22.6503L54.4554 18.5772L52.8654 22.6503H56.0453ZM53.561 17.4844H55.2503L59.1258 26.8228H57.6352L56.4428 24.0412H52.1698L51.1761 26.8228H49.6855L53.561 17.4844Z'
        fill='white'
      />
      <path
        d='M60.6163 22.0547C60.6163 18.7763 62.5044 17.2861 64.9887 17.2861C66.8767 17.2861 69.0629 18.1802 69.2616 20.5645H67.771C67.4729 19.273 66.2805 18.677 65.088 18.677C63.3987 18.677 62.1069 19.6704 62.1069 22.0547C62.1069 24.439 63.3987 25.6311 65.1874 25.6311C66.7773 25.6311 67.5723 24.6377 67.771 23.8429H69.361C69.1622 25.0351 68.0692 27.022 65.1874 27.022C62.5044 27.022 60.6163 25.3331 60.6163 22.0547Z'
        fill='white'
      />
      <path
        d='M71.249 22.0547C71.249 18.7763 73.1371 17.2861 75.6214 17.2861C77.5094 17.2861 79.6956 18.1802 79.8943 20.5645H78.4037C78.1056 19.273 76.9132 18.677 75.7207 18.677C74.0314 18.677 72.7396 19.6704 72.7396 22.0547C72.7396 24.439 74.0314 25.6311 75.8201 25.6311C77.41 25.6311 78.205 24.6377 78.4037 23.8429H79.9937C79.7949 25.0351 78.7019 27.022 75.8201 27.022C73.1371 27.022 71.249 25.3331 71.249 22.0547Z'
        fill='white'
      />
      <path
        d='M87.6456 22.6503L86.0557 18.5772L84.4658 22.6503H87.6456ZM85.1614 17.4844H86.8507L90.7262 26.8228H89.2356L88.0431 24.0412H83.7702L82.6771 26.8228H81.1865L85.1614 17.4844Z'
        fill='white'
      />
      <path
        d='M96.6881 25.5314C98.9737 25.5314 99.9674 24.0412 99.9674 22.0543C99.9674 20.4647 99.2718 18.8752 96.6881 18.8752H93.8064V25.5314H96.6881ZM92.4152 17.4844H96.6881C100.067 17.4844 101.359 19.4713 101.359 22.1536C101.359 24.8359 100.067 26.8228 96.6881 26.8228H93.8064H92.4152V17.4844Z'
        fill='white'
      />
      <path
        d='M103.445 17.4844H110.898V18.8752H104.936V21.3588H110.501V22.7497H104.936V25.5314H111.097V26.8228H103.445V17.4844Z'
        fill='white'
      />
      <path
        d='M113.481 17.4844H114.972L118.351 25.6307L121.729 17.4844H123.319V26.8228H121.829V20.4647L119.344 26.8228H117.357L114.873 20.4647V26.8228H113.481V17.4844Z'
        fill='white'
      />
      <path
        d='M126.997 17.4844H125.605V26.8228H126.997V17.4844Z'
        fill='white'
      />
      <path
        d='M135.145 22.6503L133.555 18.5772L131.965 22.6503H135.145ZM132.66 17.4844H134.35L138.225 26.8228H136.735L135.542 24.0412H131.269L130.176 26.8228H128.686L132.66 17.4844Z'
        fill='white'
      />
      <path
        d='M53.9585 38.9437C56.244 38.9437 57.2377 37.4535 57.2377 35.4666C57.2377 33.8771 56.5422 32.2876 53.9585 32.2876H51.0767V38.9437H53.9585ZM49.6855 30.9961H53.9585C57.3371 30.9961 58.6289 32.983 58.6289 35.6653C58.6289 38.3477 57.3371 40.3346 53.9585 40.3346H51.0767H49.6855V30.9961Z'
        fill='white'
      />
      <path
        d='M62.1069 30.9961H60.7157V40.3346H62.1069V30.9961Z'
        fill='white'
      />
      <path
        d='M73.7333 38.9437C76.3169 38.9437 76.9132 38.447 76.9132 37.5529C76.9132 36.3607 76.0188 36.1621 73.7333 36.1621H70.7522V39.0431H73.7333V38.9437ZM73.7333 34.7712C75.522 34.7712 76.2176 34.2745 76.2176 33.3804C76.2176 32.4863 75.522 32.2876 73.8327 32.2876H70.7522V34.7712H73.7333ZM69.361 30.9961H73.8327C76.6151 30.9961 77.6088 31.7909 77.6088 33.1817C77.6088 34.7712 76.4163 35.1686 75.3232 35.3673C76.5157 35.4666 78.205 35.566 78.205 37.6522C78.205 39.3411 77.2113 40.2352 73.6339 40.2352H69.2616V30.9961H69.361Z'
        fill='white'
      />
      <path
        d='M80.3916 30.9961H87.7451V32.2876H81.7828V34.7712H87.3476V36.1621H81.7828V38.9437H88.0432V40.2352H80.3916V30.9961Z'
        fill='white'
      />
      <path
        d='M90.3281 30.9961H91.7193V38.9437H97.9797V40.2352H90.3281V30.9961Z'
        fill='white'
      />
      <path
        d='M100.266 30.9961H101.756V38.9437H107.917V40.2352H100.266V30.9961Z'
        fill='white'
      />
      <path
        d='M110.302 30.9961H117.655V32.2876H111.693V34.7712H117.258V36.1621H111.693V38.9437H117.953V40.2352H110.302V30.9961Z'
        fill='white'
      />
      <path
        d='M130.772 36.1621L129.182 32.0889L127.592 36.1621H130.772ZM128.288 30.9961H129.977L133.853 40.3346H132.362L131.17 37.5529H126.897L125.704 40.3346H124.214L128.288 30.9961Z'
        fill='white'
      />
      <path
        d='M140.908 35.0693C142.101 35.0693 142.896 34.6719 142.896 33.6784C142.896 32.5856 141.902 32.1882 140.908 32.1882H137.033V34.9699H140.908V35.0693ZM135.641 30.9961H140.908C143.293 30.9961 144.187 32.1882 144.187 33.5791C144.187 34.8706 143.392 35.566 142.101 35.7647C142.796 35.7647 143.989 36.0627 143.989 37.7516V38.9437C143.989 39.9372 144.287 40.2352 144.287 40.2352H142.796C142.796 40.2352 142.498 39.8378 142.498 38.9437V37.7516C142.498 36.5594 141.405 36.3607 140.709 36.3607H137.033V40.2352H135.641V30.9961Z'
        fill='white'
      />
      <path
        d='M149.653 32.2876H145.877V30.9961H154.721V32.2876H151.044V40.2352H149.653V32.2876Z'
        fill='white'
      />
      <path
        d='M158.001 30.9961H156.609V40.3346H158.001V30.9961Z'
        fill='white'
      />
      <path
        d='M0 44.1094H44.1208L37.5623 6.65614L0 0V44.1094Z'
        fill='white'
      />
      <path
        d='M10.7323 12.9145L12.0242 13.0138L11.6267 5.16551L10.3349 4.96682L10.633 11.0269L5.16756 4.07271L3.77637 3.87402L3.97511 12.0204L5.3663 12.219L5.26693 5.86093L10.7323 12.9145Z'
        fill='#1E1E1E'
      />
      <path
        d='M17.3904 6.06002L15.8998 5.86133L12.8193 13.1135L14.2105 13.3122L15.1049 11.0273L18.9803 11.524L20.2722 14.0077L21.564 14.2063L17.3904 6.06002ZM15.5024 10.0338L16.6948 6.95413L18.3841 10.5306L15.5024 10.0338Z'
        fill='#1E1E1E'
      />
      <path
        d='M26.2342 10.9274C27.1285 10.9274 28.0229 10.7287 27.8241 9.43721C27.7247 8.34441 26.8304 7.54965 24.5449 7.25161L21.365 6.75488L22.16 14.4045L25.3398 14.8019C28.321 15.1992 29.0166 14.5038 28.8178 13.113C28.6191 11.4241 27.2279 11.1261 26.2342 10.9274ZM22.6568 7.94703L24.6442 8.24506C26.0354 8.44376 26.6317 8.74179 26.731 9.43721C26.8304 10.1326 26.2342 10.53 24.843 10.232L22.9549 9.93394L22.6568 7.94703ZM25.2405 13.7091L23.3524 13.411L23.0543 11.0267L24.9423 11.3248C26.8304 11.6228 27.6254 11.9208 27.7247 12.815C27.8241 13.6097 27.3273 13.9078 25.2405 13.7091Z'
        fill='#1E1E1E'
      />
      <path
        d='M32.6931 8.64303L31.4012 8.44434L29.3145 15.3985L30.5069 15.5972L31.1031 13.4116L34.4817 13.9083L35.7736 16.2926L36.8667 16.392L32.6931 8.64303ZM31.4012 12.3188L32.1962 9.33844L33.8855 12.6168L31.4012 12.3188Z'
        fill='#1E1E1E'
      />
    </svg>
  </Link>
)

export default Logo
